export default __webpack_public_path__ + "static/media/room-2Bed-double.91858695.jpg";